import React from 'react'

import { makeStyles } from '@material-ui/core/styles'

import Select from '@material-ui/core/Select'
import MenuItem from '@material-ui/core/MenuItem'

import resourceSettings from 'settings/resources'

const {
  getSections,
} = resourceSettings

const useStyles = makeStyles(theme => ({
  root: {
    width: '100%',
  }
}))

const SectionSelect = ({
  value,
  onChange,
  className,
  includeFilter,
  excludeFilter,
}) => {

  const classes = useStyles()
  
  const useSections = getSections({
    includeFilter,
    excludeFilter,
  })
  
  return (
    <Select
      value={ value }
      onChange={ onChange }
      className={ `${classes.root} ${className}` }
    >
      {
        useSections.map((section, i) => {
          return (
            <MenuItem 
              value={ section.id }
              key={ i }
            >
              { section.title }
            </MenuItem>
          )
        })
      }
    </Select>
  )
}

export default SectionSelect

